// Card utility functions - extracted from public/card-ui.js
// Pure functions for card image URLs, no DOM manipulation

/**
 * Get Scryfall image URL from card data
 * Works with both full Scryfall API response and minimal TradeCard objects
 * @param {Object} cardData - Card data object
 * @param {string} [size='normal'] - Image size: 'small', 'normal', 'large', 'png', 'art_crop', 'border_crop'
 * @returns {string|null}
 */
export function getCardImageUrl(cardData, size = 'normal') {
  if (!cardData) return null;

  // Full Scryfall card object with image_uris (skip empty objects from DFCs)
  if (cardData.image_uris?.normal) {
    return cardData.image_uris[size] || cardData.image_uris.normal;
  }

  // Double-faced card - use front face
  if (cardData.card_faces?.[0]?.image_uris) {
    return cardData.card_faces[0].image_uris[size] || cardData.card_faces[0].image_uris.normal;
  }

  // Minimal TradeCard - construct URL from scryfallId
  // Scryfall image URLs follow the pattern: https://cards.scryfall.io/{size}/front/{id[0]}/{id[1]}/{id}.jpg
  if (cardData.scryfallId) {
    const id = cardData.scryfallId;
    return `https://cards.scryfall.io/${size}/front/${id[0]}/${id[1]}/${id}.jpg`;
  }

  return null;
}

/**
 * Get back face image URL for double-faced cards.
 * @param {Object} cardData - Card data object
 * @param {string} [size='large'] - Image size
 * @returns {string|null}
 */
export function getCardBackImageUrl(cardData, size = 'large') {
  if (!cardData?.card_faces?.[1]?.image_uris) return null;
  return cardData.card_faces[1].image_uris[size] || cardData.card_faces[1].image_uris.normal;
}
